module.exports = __webpack_public_path__ + "6da8ad11e9f1b1fb06d079f8f51e7af3.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-fr.html
// module id = 993
// module chunks = 0